import React from 'react';

import { useSelector } from 'react-redux';

import { DatabaseIcon } from 'components/Icons';
import { AnalyzedCard } from 'containers/Visibility/Data/Components/Dashboard/Cards/AnalyzedCard';
import { selectDataDashboard } from 'containers/Visibility/Data/selectors';

export const DisksCard = () => {
  const {
    analyzedSources,
    summaryOfAllDataSources,
    sensitiveDataByAgnosticSources,
  } = useSelector(selectDataDashboard);
  const dataSources = summaryOfAllDataSources.data?.resource_type_counts;
  const sensitiveData = sensitiveDataByAgnosticSources.data;

  return (
    <AnalyzedCard
      label="Disks"
      isLoading={analyzedSources.isLoading}
      icon={<DatabaseIcon />}
      total={dataSources?.Others ?? 0}
      analyzed={analyzedSources.data?.Others ?? 0}
      sensitiveDataCount={sensitiveData?.Others ?? 0}
    />
  );
};
